import { useState } from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import toast from "react-hot-toast";
import cls from 'classnames'

import BottomSheetModalHOC from "@qoohoo/common/library/modals/BottomSheetModalHOC";
import ShareModal from "./ShareModal";
import Modal from "@qoohoo/common/library/modals/Modal";

import * as Track from "@qoohoo/common/utils/analytics/track";
import { button, link } from "@qoohoo/common/constants/analytics";
import useSessionStore from "../../../store/sessionStore";
import {
  getWhatsappShareUrl,
  getTelegramShareUrl,
  prepareShareObject,
} from "@qoohoo/common/utils/social-share";

const ShareButtonGroup = ({
  channelName,
  channelType,
  shareMessage,
  shareUrl,
  creatorDetails,
  trackDetails,
  isWhiteTheme
}) => {
  const userData = useSessionStore((state) => state.userData);
  const isCreatorLoggedIn = userData.username === creatorDetails.username;

  const [shareModalOpen, setshareModalOpen] = useState(false);

  let defaultShareText = `I invite you to join this Telegram ${channelType} ${channelName}\n`;

  if (isCreatorLoggedIn) {
    defaultShareText = `I invite you to join my Telegram ${channelType} ${channelName}\n`;
  }

  let _shareMessage = `${
    shareMessage ? shareMessage + "\n" : ""
  }${defaultShareText}`;

  const shareObject = prepareShareObject(shareUrl, _shareMessage);

  function openShareModal() {
    setshareModalOpen(true);

    Track.buttonClick(button.share_options, trackDetails);
  }

  function closeShareModal() {
    setshareModalOpen(false);
  }

  function getWhatsappShareText() {
    const whatsappShareText = getWhatsappShareUrl({
      text: shareObject.encodedTextWithUrl,
    });

    return whatsappShareText;
  }

  function getTelegramShareText() {
    const telegramShareText = getTelegramShareUrl({
      url: shareObject.encodedUrl,
      text: shareObject.encodedText,
    });

    return telegramShareText;
  }

  return (
    <>
      <div className="sm:flex sm:flex-col sm:items-center sm:absolute sm:top-4 sm:-right-5 sm:translate-x-full sm:z-0">
        <h3 className="hidden sm:block text-sm font-semibold text-[#B4BCC3] mb-4">
          Share
        </h3>
        <div className="mt-6 px-2 sm:mt-0 sm:px-0 flex flex-row sm:flex-col space-x-3 sm:space-x-0 sm:space-y-6">
          <a
            href={getWhatsappShareText()}
            target="_blank"
            className="p-2 bg-[#1C1F21] hover:bg-opacity-60 border border-[#262A2D] outline-none rounded-full dark:bg-white dark:border-[#D5D8DC]"
            onClick={() => {
              Track.linkClick(link.share_via_whatsapp, {
                ...trackDetails,
                url: shareUrl,
                message: shareMessage,
              });
            }}
          >
            <img
              src="/assets/social-icons/whatsapp-original.svg"
              className="w-6 sm:w-7 h-6 sm:h-7"
            />
          </a>
          <a
            href={getTelegramShareText()}
            target="_blank"
            className="p-2 bg-[#1C1F21] hover:bg-opacity-60 border border-[#262A2D] outline-none rounded-full dark:bg-white dark:border-[#D5D8DC]"
            onClick={() => {
              Track.linkClick(link.share_via_telegram, {
                ...trackDetails,
                url: shareUrl,
                message: shareMessage,
              });
            }}
          >
            <img
              src="/assets/icons/telegram.svg"
              className="w-6 sm:w-7 h-6 sm:h-7"
            />
          </a>
          <CopyToClipboard
            text={shareObject.textWithUrl}
            onCopy={() => {
              toast.success("Sharable link copied!");

              Track.buttonClick(button.copy_link, {
                ...trackDetails,
                link: shareUrl,
              });
            }}
          >
            <div className="p-3 bg-[#1C1F21] hover:bg-opacity-60 border border-[#262A2D] outline-none rounded-full cursor-pointer dark:bg-white dark:border-[#D5D8DC]">
              {
                isWhiteTheme?
                <img
                  src="/assets/icons/link-dark.svg"
                  className="w-4 sm:w-5 h-4 sm:h-5"
                />
                :
                <img
                  src="/assets/icons/link.svg"
                  className="w-4 sm:w-5 h-4 sm:h-5"
                />
              }
            </div>
          </CopyToClipboard>
          <button
            className="p-2 sm:p-3 bg-[#1C1F21] hover:bg-opacity-60 border border-[#262A2D] outline-none rounded-full dark:bg-white dark:border-[#D5D8DC]"
            onClick={openShareModal}
          >
            {
              isWhiteTheme?
              <img
                src="/assets/icons/more-dark.svg"
                className="w-6 sm:w-5 h-6 sm:h-5"
              />
              :
              <img
                src="/assets/icons/more.svg"
                className="w-6 sm:w-5 h-6 sm:h-5"
              />
            }
          </button>
        </div>
      </div>

      {/* Share Modal For Gated Post */}
      <Modal isOpen={shareModalOpen} closeModal={closeShareModal} className={cls(isWhiteTheme?"dark":"")}>
        <BottomSheetModalHOC>
          <ShareModal
            creatorDetails={creatorDetails}
            closeModal={closeShareModal}
            shareText={shareObject.textWithUrl}
            url={shareUrl}
            message={_shareMessage}
            isWhiteTheme={isWhiteTheme}
          />
        </BottomSheetModalHOC>
      </Modal>
    </>
  );
};

export default ShareButtonGroup;
